import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const faqData = [
  {
    question: "Do I need to enter my credit card details to sign up?",
    answer: "No. We do not require any payment details for the free sign up.",
  },
  {
    question: "How do I get more credits?",
    answer:
      "On Free sign up, you will get 10 non-expiring credits with limited access to all the tools. You can subscribe to any of the paid plans to get more credits and unlock access to all the tools that we built and are going to build!",
  },
  {
    question: "What happens if I exceed the credit limit?",
    answer:
      "After exceeding the limit, you can't access the tools but you can always upgrade your subscription to get more credits. Also, your credits will be automatically renewed after your current billing period if your subscription is active.",
  },
  {
    question: "Will my credits reduce if the tool failed to do the job?",
    answer:
      "You don't lose your credits if the tools failed to do the job at odd times.",
  },
  {
    question:
      "How long does it take for my credits to get reflected on my dashboard after I purchase a subscription?",
    answer:
      "Once we receive the subscription payment from Stripe, your credits will get updated instantly on your dashboard. It won't take more than 30 seconds.",
  },
  {
    question: "How can I check my available credits and consumed credits?",
    answer: "You can see the credits usage in your dashboard.",
  },
  {
    question: "How do we handle the payment?",
    answer:
      "Your payments will be taken care of by Stripe, and your payment details never touch our servers.",
  },
  {
    question: "Can I downgrade to Free plan from any of the paid plans?",
    answer:
      "Yes, you can place a cancel subscription request and your subscription will be scheduled for cancellation at the end of your billing period. Then, you'll be automatically subscribed to the Free plan and no further charges will be deducted.",
  },
  {
    question: "Can I upgrade from a lower paid plan to a higher paid plan?",
    answer:
      "Yes, you can upgrade your subscription and your upgrade request will be processed immediately on a prorated basis.",
  },
  {
    question: "Do you offer a discount on an annual subscription?",
    answer: "Yes, we offer a 50% discount on an annual subscription.",
  },
  {
    question: "I still have more questions about pricing. What should I do?",
    answer: "Please contact us. We'll be happy to answer all your questions :)",
  },
];

const FAQSection = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 8 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 4, textAlign: "center" }}>
        Frequently Asked Questions
      </Typography>
      {faqData.map((faq, index) => (
        <Accordion key={index} sx={{ mb: 2 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1" fontWeight={600}>
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textAlign: "left" }}
            >
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  );
};

export default FAQSection;
